export function cheapestCachedDeals(deals = [], limit = Infinity) {
  return deals.filter(deal => Number.isFinite(Number(deal.price)) && Number(deal.price) > 0)
    .slice().sort((a, b) => Number(a.price) - Number(b.price) || String(a.destinationName).localeCompare(String(b.destinationName)))
    .slice(0, limit);
}

export function cachedDealKey(deal) {
  return deal.dealId || `${deal.destinationName}-${deal.destinationCountry}-${deal.tripWeeks || deal.tripDays}`;
}

export function refreshAge(timestamp, now) {
  if (!timestamp || !Number.isFinite(Date.parse(timestamp))) return "Awaiting first refresh";
  const hours = Math.max(0, Math.floor((now - Date.parse(timestamp)) / 3600000));
  return hours < 1 ? "Updated less than an hour ago" : `Updated ${hours} ${hours === 1 ? "hour" : "hours"} ago`;
}

export function cachedDealLoginLink(origin, deal) {
  const params = new URLSearchParams({ origin });
  if (deal.dealId) params.set("deal", deal.dealId);
  return `/login?next=${encodeURIComponent(`/prefetched-deals?${params}`)}`;
}
